// dependencies
import { Map } from "immutable";
import { getMatchedRoute } from "yarrr";

export const getPageName = (state) => {
	const matchedRoute = getMatchedRoute(state, null);
	return matchedRoute ? matchedRoute.name : "_CURRENT_";
};

export const getUI = (state) => {
	const pageName = getPageName(state);
	return state.getIn(["ui", pageName], Map());
};
